(function(){
  'use strict';
  const db=()=>window.SM.DB, ui=()=>window.SM.UI, util=()=>window.SM.UTIL;
  let _activeTab='orders';

  async function load(){
    const tbody=document.getElementById('ims-po-tbody');
    if(!tbody)return;
    tbody.innerHTML=`<tr><td colspan="7" class="ims__table-empty"><i class="ti ti-loader-2 ims__spin"></i></td></tr>`;
    const search=document.getElementById('ims-po-search')?.value?.trim().toLowerCase()||'';
    const status=document.getElementById('ims-po-status')?.value||'';
    const opts={select:'id,po_number,status,total_value,currency,expected_delivery,created_at,suppliers(name),po_items(id)',order:{col:'created_at',asc:false}};
    if(status)opts.eq={status};
    const {data:pos,error}=await db().select('purchase_orders',opts);
    if(error){ui().toast('Failed to load POs','error');return;}
    let items=pos||[];
    if(search)items=items.filter(p=>p.po_number?.toLowerCase().includes(search)||p.suppliers?.name?.toLowerCase().includes(search));
    if(!items.length){tbody.innerHTML='<tr><td colspan="7" class="ims__table-empty">No purchase orders found</td></tr>';return;}
    tbody.innerHTML=items.map(p=>`<tr>
      <td><span class="ims__link" onclick="window.IMS_PURCHASES.openPO('${p.id}')">${util().sanitize(p.po_number)}</span></td>
      <td>${util().sanitize(p.suppliers?.name||'—')}</td>
      <td>${(p.po_items||[]).length||'—'}</td>
      <td>${util().formatCurrency(p.total_value)} <span style="font-size:11px;color:var(--ims-text-muted)">${p.currency!=='GBP'?p.currency:''}</span></td>
      <td>${p.expected_delivery?util().formatDate(p.expected_delivery):'—'}</td>
      <td>${util().pill(p.status)}</td>
      <td><div class="ims__btn-group">
        <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_PURCHASES.openPO('${p.id}')"><i class="ti ti-eye"></i></button>
        <button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_PURCHASES.printPO('${p.id}')"><i class="ti ti-printer"></i></button>
        ${window.SM.AUTH.hasRole('super_admin')?`<button class="ims__btn ims__btn--danger ims__btn--sm ims__btn--icon" onclick="window.IMS_PURCHASES.deletePO('${p.id}','${util().sanitize(p.po_number)}')" title="Delete PO"><i class="ti ti-trash"></i></button>`:''}
      </div></td>
    </tr>`).join('');
  }

  async function openPO(id){
    const {data:po}=await db().select('purchase_orders',{select:'*, suppliers(*), po_items(*, products(name,sku))',eq:{id},maybeSingle:true,noCompanyFilter:true});
    // Check if a container is linked to this PO
    const {data:linkedContainer}=await db().select('imports',{select:'id,container_number',eq:{po_id:id},maybeSingle:true,noCompanyFilter:true});
    if(po) po.has_container=!!linkedContainer;
    if(po) po.container_number=linkedContainer?.container_number||null;
    if(!po)return;
    const itemCount=(po.po_items||[]).length;
    const receivedItems=(po.po_items||[]).filter(i=>i.qty_received>0).length;
    ui().openModal(`PO: ${po.po_number}`,`
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:14px">
        <div><span class="ims__label">PO Number</span><div style="font-weight:700;font-size:16px">${util().sanitize(po.po_number)}</div></div>
        <div><span class="ims__label">Status</span><div>${util().pill(po.status)}</div></div>
        <div><span class="ims__label">Supplier</span><div>${util().sanitize(po.suppliers?.name||'—')}</div></div>
        <div><span class="ims__label">Currency</span><div>${po.currency||'GBP'}</div></div>
        <div><span class="ims__label">Expected delivery</span><div>${po.expected_delivery?util().formatDate(po.expected_delivery):'—'}</div></div>
        <div><span class="ims__label">Total value</span><div style="font-weight:700">${util().formatCurrency(po.total_value)}</div></div>
        ${po.notes?`<div style="grid-column:1/-1"><span class="ims__label">Notes</span><div>${util().sanitize(po.notes)}</div></div>`:''}
        ${po.has_container?`<div style="grid-column:1/-1"><div class="ims__alert ims__alert--info" style="margin:0"><i class="ti ti-container"></i><span>Linked to container <strong>${util().sanitize(po.container_number)}</strong> — receive goods via the Imports module GRN process</span></div></div>`:''}
      </div>
      <hr class="ims__divider">
      <strong style="font-size:13px">Order items</strong>
      <div class="ims__table-wrap" style="margin-top:8px">
        <table class="ims__table">
          <thead><tr><th>Product</th><th>SKU</th><th>Qty ordered</th><th>Qty received</th><th>Unit cost</th><th>Total</th></tr></thead>
          <tbody>${(po.po_items||[]).map(item=>`<tr>
            <td>${util().sanitize(item.product_name||item.products?.name||'—')}</td>
            <td>${util().sanitize(item.sku||item.products?.sku||'—')}</td>
            <td>${item.quantity}</td>
            <td><span class="ims__pill ims__pill--${item.qty_received>=item.quantity?'success':item.qty_received>0?'warning':'neutral'}">${item.qty_received||0}</span></td>
            <td>${util().formatCurrency(item.unit_cost)}</td>
            <td>${util().formatCurrency(item.total_cost)}</td>
          </tr>`).join('')||'<tr><td colspan="6" class="ims__table-empty">No items</td></tr>'}
          <tr><td colspan="5" style="text-align:right;font-weight:600">Total</td><td style="font-weight:700">${util().formatCurrency(po.total_value)}</td></tr>
          </tbody>
        </table>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.IMS_PURCHASES.printPO('${po.id}')"><i class="ti ti-printer"></i> Print</button>
      ${(po.po_items||[]).some(i=>(i.qty_received||0)>0)?`
        <button class="ims__btn ims__btn--secondary" onclick="window.IMS_PURCHASES.printPutAwayForPO('${po.id}')"><i class="ti ti-printer"></i> Put-away sheet</button>
        <button class="ims__btn ims__btn--secondary" onclick="window.IMS_PURCHASES.enterPutAwayLocations('${po.id}')"><i class="ti ti-map-pin"></i> Update locations</button>
      `:''}
      ${window.SM.AUTH.hasRole('super_admin')?`<button class="ims__btn ims__btn--danger" onclick="window.IMS_PURCHASES.deletePO('${po.id}','${util().sanitize(po.po_number)}')"><i class="ti ti-trash"></i> Delete PO</button>`:''}
      ${(()=>{
        const canReceive=['approved','sent','partially_received'].includes(po.status);
        const allReceived=(po.po_items||[]).length>0&&(po.po_items||[]).every(i=>(i.qty_received||0)>=(i.quantity||0));
        if(!canReceive)return '';
        if(allReceived)return `<button class="ims__btn ims__btn--secondary" disabled title="All items fully received"><i class="ti ti-package-import"></i> Fully received</button>`;
        if(po.has_container)return `<button class="ims__btn ims__btn--secondary" disabled title="Goods must be received via the linked container GRN"><i class="ti ti-package-import"></i> Receive via GRN</button>`;
        return `<button class="ims__btn ims__btn--secondary" onclick="window.IMS_PURCHASES.receiveGoods('${po.id}')"><i class="ti ti-package-import"></i> Receive goods</button>`;
      })()}
      <div style="display:flex;gap:8px;align-items:center">
        ${po.status==='completed'?
          `<span style="font-size:12px;color:var(--ims-success)"><i class="ti ti-circle-check"></i> PO completed</span>`
        :`<select class="ims__select" id="ims-po-status-sel" style="font-size:12px;width:auto">
          <option value="">Update status...</option>
          <option value="approved">Approved</option><option value="sent">Sent to supplier</option>
          <option value="partially_received">Partially received</option>
          <option value="completed">Completed</option><option value="cancelled">Cancelled</option>
        </select>
        <button class="ims__btn ims__btn--primary" onclick="window.IMS_PURCHASES.updatePOStatus('${po.id}')">Update</button>`}
        <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Close</button>
      </div>
    `,'lg');
  }

  async function updatePOStatus(poId){
    const sel=document.getElementById('ims-po-status-sel');
    if(!sel?.value)return;
    await db().update('purchase_orders',poId,{status:sel.value});
    ui().closeModal();ui().toast('PO status updated','success');load();
  }
  async function deletePO(id, poNumber){
    if(!window.SM.AUTH.hasRole('super_admin')){ui().toast('Super Admin only','error');return;}

    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);

    // Block if any items already received
    const {data:received}=await client.from('po_items')
      .select('qty_received')
      .eq('po_id',id)
      .gt('qty_received',0)
      .limit(1);
    if(received?.length){
      ui().toast('Cannot delete — goods have already been received against this PO. Stock would become untracked.','error',6000);
      return;
    }

    // Block if a container is linked
    const {data:linkedImport}=await db().select('imports',{select:'id,container_number',eq:{po_id:id},maybeSingle:true,noCompanyFilter:true});
    if(linkedImport){
      ui().toast(`Cannot delete — this PO is linked to container ${linkedImport.container_number}. Delete the import first if needed.`,'error',6000);
      return;
    }

    ui().confirm(
      `Permanently delete PO "${poNumber}"? This will also delete all line items and the linked payable. This cannot be undone.`,
      async()=>{
        await client.from('po_items').delete().eq('po_id',id);
        await client.from('accounts_payable').delete().eq('po_id',id);
        const {error}=await client.from('purchase_orders').delete().eq('id',id);
        if(error){ui().toast('Failed: '+error.message,'error');return;}
        ui().closeModal();
        ui().toast(`PO ${poNumber} deleted`,'success');
        load();
      },
      'Delete PO',
      true
    );
  }

  let _poItems=[];

  async function showNewPO(){
    _poItems=[];
    const {data:suppliers}=await db().select('suppliers',{eq:{is_active:true},order:{col:'name'}});
    const supOpts=(suppliers||[]).map(s=>`<option value="${s.id}" data-currency="${s.currency||'GBP'}">${util().sanitize(s.name)}</option>`).join('');

    // Pre-generate next PO number so user can see and optionally override it
    const {data:lastPO}=await db().select('purchase_orders',{select:'po_number',order:{col:'created_at',asc:false},limit:1});
    const nextPONumber=util().generateRef('PO',lastPO?.[0]?.po_number);

    ui().openModal('New purchase order',`
      <div class="ims__form-grid">
        <div class="ims__form-group"><label class="ims__label ims__label--req">PO number</label>
          <input class="ims__input" type="text" id="ims-newpo-ponum" value="${nextPONumber}" placeholder="e.g. PO-00003">
          <span class="ims__input-hint">Auto-generated — edit if needed</span>
        </div>
        <div class="ims__form-group"><label class="ims__label ims__label--req">Supplier</label><select class="ims__select" id="ims-newpo-supplier" onchange="window.IMS_PURCHASES.onSupplierChange()"><option value="">Select supplier</option>${supOpts}</select></div>
        <div class="ims__form-group"><label class="ims__label">Currency</label><select class="ims__select" id="ims-newpo-currency"><option value="GBP">GBP (£)</option><option value="USD">USD ($)</option><option value="EUR">EUR (€)</option><option value="CNY">CNY (¥)</option><option value="PKR">PKR (₨)</option></select></div>
        <div class="ims__form-group"><label class="ims__label">Expected delivery</label><input class="ims__input" type="date" id="ims-newpo-delivery"></div>
        <div class="ims__form-group"><label class="ims__label">Status</label><select class="ims__select" id="ims-newpo-status"><option value="draft">Draft</option><option value="approved">Approved</option><option value="sent">Sent to supplier</option></select></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label">Notes</label><textarea class="ims__textarea" id="ims-newpo-notes" rows="2"></textarea></div>
      </div>
      <hr class="ims__divider">
      <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:10px">
        <strong style="font-size:13px">Order items</strong>
        <button class="ims__btn ims__btn--secondary ims__btn--sm" onclick="window.IMS_PURCHASES.addPOItem()"><i class="ti ti-plus"></i> Add item</button>
      </div>
      <div id="ims-newpo-items"><div style="font-size:12px;color:var(--ims-text-muted);padding:8px 0">No items added yet</div></div>
      <hr class="ims__divider">
      <div style="display:flex;justify-content:flex-end;align-items:center;gap:12px">
        <span style="font-size:13px;color:var(--ims-text-sec)">Total:</span>
        <span style="font-size:20px;font-weight:700" id="ims-newpo-total">${util().formatCurrency(0)}</span>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_PURCHASES.savePO()"><i class="ti ti-check"></i> Create PO</button>
    `,'lg');
  }

  function onSupplierChange(){
    const sel=document.getElementById('ims-newpo-supplier');
    const currSel=document.getElementById('ims-newpo-currency');
    if(!sel||!currSel)return;
    const opt=sel.options[sel.selectedIndex];
    const currency=opt?.dataset?.currency||'GBP';
    if(currSel)currSel.value=currency;
  }

  function addPOItem(){_poItems.push({productId:'',productName:'',sku:'',qty:1,unitCost:0});renderPOItems();}

  function renderPOItems(){
    const c=document.getElementById('ims-newpo-items');
    if(!c)return;
    if(!_poItems.length){c.innerHTML='<div style="font-size:12px;color:var(--ims-text-muted);padding:8px 0">No items added yet</div>';updatePOTotal();return;}
    c.innerHTML=_poItems.map((item,i)=>`
      <div style="display:grid;grid-template-columns:2fr 80px 110px auto;gap:8px;align-items:center;margin-bottom:8px">
        <div style="position:relative">
          <input class="ims__input" type="text" placeholder="Product name or SKU" value="${util().sanitize(item.productName)}" autocomplete="off"
            oninput="window.IMS_PURCHASES.updatePOItem(${i},'productName',this.value);window.IMS_PURCHASES.searchPOProduct(${i},this.value)">
          <div id="ims-po-prod-drop-${i}" class="ims__ac-dropdown"></div>
        </div>
        <input class="ims__input" type="number" min="1" value="${item.qty}" placeholder="Qty" oninput="window.IMS_PURCHASES.updatePOItem(${i},'qty',+this.value||1)">
        <input class="ims__input" type="number" min="0" step="0.01" value="${item.unitCost}" placeholder="Unit cost" oninput="window.IMS_PURCHASES.updatePOItem(${i},'unitCost',+this.value||0)">
        <button class="ims__btn ims__btn--danger ims__btn--sm ims__btn--icon" onclick="window.IMS_PURCHASES.removePOItem(${i})"><i class="ti ti-trash"></i></button>
      </div>`).join('');
    updatePOTotal();
  }

  function updatePOItem(i,field,val){if(_poItems[i]){_poItems[i][field]=val;updatePOTotal();}}
  function removePOItem(i){_poItems.splice(i,1);renderPOItems();}
  function updatePOTotal(){
    const total=_poItems.reduce((s,i)=>s+((i.qty||1)*(i.unitCost||0)),0);
    const el=document.getElementById('ims-newpo-total');if(el)el.textContent=util().formatCurrency(total);
  }

  async function searchPOProduct(index,query){
    if(!query||query.length<2){const d=document.getElementById(`ims-po-prod-drop-${index}`);if(d)d.style.display='none';return;}
    const {data:products}=await db().select('products',{ilike:{name:query},select:'id,name,sku',limit:6});
    const drop=document.getElementById(`ims-po-prod-drop-${index}`);
    if(!drop||!products?.length){if(drop)drop.style.display='none';return;}
    drop.innerHTML=await Promise.all(products.map(async p=>{
      const cost=await db().getProductPrice(p.id,'cost');
      return `<div class="ims__ac-item" onmousedown="window.IMS_PURCHASES.selectPOProduct(${index},${JSON.stringify({id:p.id,name:p.name,sku:p.sku,cost:cost||0}).replace(/"/g,'&quot;')})"><strong>${util().sanitize(p.name)}</strong><span style="font-size:11px;color:var(--ims-text-muted);margin-left:6px">${p.sku}${cost!==null?' — Cost: '+util().formatCurrency(cost):''}</span></div>`;
    })).then(rows=>rows.join(''));
    drop.style.display='block';
  }

  function selectPOProduct(index,product){
    if(_poItems[index]){_poItems[index].productId=product.id;_poItems[index].productName=product.name;_poItems[index].sku=product.sku;_poItems[index].unitCost=product.cost||0;}
    renderPOItems();
    const drop=document.getElementById(`ims-po-prod-drop-${index}`);if(drop)drop.style.display='none';
  }

  

  async function printPO(id){
    const {data:po}=await db().select('purchase_orders',{select:'*, suppliers(*), po_items(*)',eq:{id},maybeSingle:true,noCompanyFilter:true});
    if(!po)return;

    const infoRows=[
      ['Supplier', util().sanitize(po.suppliers?.name||'—')],
      ['Currency', po.currency||'GBP'],
      ['Expected delivery', po.expected_delivery?util().formatDate(po.expected_delivery):'—'],
      ['Status', util().sanitize(po.status)]
    ];
    const infoTableHtml=window.PRINT.table({
      colWidths:['30%','70%'],
      columns:[{label:'Field'},{label:'Value'}],
      rows:infoRows
    });

    const itemRows=(po.po_items||[]).map(i=>[
      util().sanitize(i.product_name||'—'),
      util().sanitize(i.sku||'—'),
      String(i.quantity),
      util().formatCurrency(i.unit_cost),
      util().formatCurrency(i.total_cost)
    ]);
    const totalsRow=[
      '<td colspan="4" style="text-align:right">Total</td>',
      `<td class="r">${util().formatCurrency(po.total_value)}</td>`
    ];
    const itemTableHtml=window.PRINT.table({
      colWidths:['34%','18%','12%','18%','18%'],
      columns:[
        {label:'Product'},{label:'SKU'},{label:'Qty',align:'r'},
        {label:'Unit cost',align:'r'},{label:'Total',align:'r'}
      ],
      rows:itemRows,
      totalsRow:totalsRow
    });

    const headerHtml=window.PRINT.header({
      title:'Purchase Order',
      docRef:po.po_number
    });

    const page=`
      ${headerHtml}
      <hr class="rule">
      ${infoTableHtml}
      <div class="st" style="margin-top:14px">Items</div>
      <hr class="rule">
      ${itemTableHtml}
    `;

    window.PRINT.renderDocument([page],`PO ${po.po_number}`);
  }

  async function savePO(){
    const g=id=>document.getElementById(id)?.value?.trim()||'';
    const supplierId=g('ims-newpo-supplier');
    if(!supplierId){ui().toast('Please select a supplier','error');return;}
    if(!_poItems.length){ui().toast('Please add at least one item','error');return;}
    const poNumber=g('ims-newpo-ponum');
    if(!poNumber){ui().toast('PO number is required','error');return;}
    const total=_poItems.reduce((s,i)=>s+((i.qty||1)*(i.unitCost||0)),0);

    const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
    const {data:po,error}=await client.from('purchase_orders').insert({
      po_number:poNumber,supplier_id:supplierId,
      company_id:window.SM.AUTH.company?.id,
      status:g('ims-newpo-status')||'draft',
      currency:g('ims-newpo-currency')||'GBP',
      expected_delivery:g('ims-newpo-delivery')||null,
      notes:g('ims-newpo-notes')||null,
      total_value:total,
      created_by:window.SM.AUTH.user?.id
    }).select().single();
    if(error){ui().toast('Failed: '+error.message,'error');return;}
    if(!po?.id){ui().toast('PO created but ID not returned — contact support','error');return;}

    const itemErrors=[];
    await Promise.all(_poItems.map(async item=>{
      const {error:itemErr}=await client.from('po_items').insert({
        po_id:po.id,
        product_id:item.productId||null,
        product_name:item.productName||'',
        sku:item.sku||'',
        quantity:item.qty||1,
        unit_cost:item.unitCost||0,
        total_cost:(item.qty||1)*(item.unitCost||0),
        qty_received:0
      });
      if(itemErr) itemErrors.push(itemErr.message);
    }));
    if(itemErrors.length) ui().toast(`PO created but ${itemErrors.length} item(s) failed to save: ${itemErrors[0]}`,'warning');

    await db().insert('accounts_payable', {
      supplier_id:supplierId,po_id:po.id,
      invoice_ref:poNumber,amount:total,
      currency:g('ims-newpo-currency')||'GBP',
      status:'unpaid'
    });

    _poItems=[];
    ui().closeModal();ui().toast(`PO ${poNumber} created`,'success');load();
  }

  async function receiveGoods(poId){
    const {data:po}=await db().select('purchase_orders',{select:'*, po_items(*, products(name,sku))',eq:{id:poId},maybeSingle:true,noCompanyFilter:true});
    if(!po)return;
    const {data:whs}=await db().select('warehouses',{eq:{is_active:true}});
    const whOpts=(whs||[]).map(w=>`<option value="${w.id}">${util().sanitize(w.name)}</option>`).join('');
    ui().openModal(`Receive goods: ${po.po_number}`,`
      <p style="font-size:13px;color:var(--ims-text-sec);margin-bottom:14px">Enter quantities received. Leave as 0 if not yet received.</p>
      <div class="ims__form-group" style="margin-bottom:14px">
        <label class="ims__label ims__label--req">Destination warehouse</label>
        <select class="ims__select" id="ims-recv-wh"><option value="">Select warehouse</option>${whOpts}</select>
      </div>
      <div class="ims__table-wrap">
        <table class="ims__table">
          <thead><tr><th>Product</th><th>SKU</th><th>Ordered</th><th>Previously received</th><th>Receiving now</th></tr></thead>
          <tbody>${(po.po_items||[]).map((item,i)=>`<tr>
            <td>${util().sanitize(item.product_name||item.products?.name||'—')}</td>
            <td>${util().sanitize(item.sku||item.products?.sku||'—')}</td>
            <td>${item.quantity}</td>
            <td>${item.qty_received||0}</td>
            <td><input class="ims__input" type="number" min="0" max="${item.quantity-(item.qty_received||0)}" value="0" id="ims-recv-qty-${i}" data-item-id="${item.id}" data-product-id="${item.product_id||''}" style="width:80px"></td>
          </tr>`).join('')}
          </tbody>
        </table>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Cancel</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_PURCHASES.confirmReceiving('${poId}',${(po.po_items||[]).length})"><i class="ti ti-package-import"></i> Confirm receiving</button>
    `,'lg');
  }

  async function confirmReceiving(poId,itemCount){
    const warehouseId=document.getElementById('ims-recv-wh')?.value;
    if(!warehouseId){ui().toast('Please select a warehouse','error');return;}
    let totalReceived=0;
    for(let i=0;i<itemCount;i++){
      const input=document.getElementById(`ims-recv-qty-${i}`);
      if(!input)continue;
      const qty=parseInt(input.value)||0;
      const itemId=input.dataset.itemId;
      const productId=input.dataset.productId;
      if(qty<=0)continue;
      totalReceived+=qty;
      // Update po_item qty_received
      const client=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
      const {data:poItem}=await client.from('po_items').select('qty_received').eq('id',itemId).single();
      await client.from('po_items').update({qty_received:(poItem?.qty_received||0)+qty}).eq('id',itemId);
      // Update stock
      if(productId){
        const {data:prod}=await db().select('products',{select:'default_bin',eq:{id:productId},maybeSingle:true,noCompanyFilter:true});
        const defaultBin=prod?.default_bin||null;
        const {data:existing}=await db().select('stock_levels',{eq:{product_id:productId,warehouse_id:warehouseId},maybeSingle:true,noCompanyFilter:true});
        if(existing){
          await db().update('stock_levels',existing.id,{
            quantity:(existing.quantity||0)+qty,
            bin_reference:existing.bin_reference||defaultBin,
            last_updated:new Date().toISOString()
          });
        } else {
          await db().insert('stock_levels',{
            product_id:productId,warehouse_id:warehouseId,
            quantity:qty,reserved_qty:0,
            bin_reference:defaultBin
          });
        }
        await db().insert('stock_movements',{product_id:productId,warehouse_id:warehouseId,movement_type:'import_received',quantity:qty,reference:`PO-${poId}`,reason:'PO receiving',user_id:window.SM.AUTH.user?.id});
      }
    }
    if(totalReceived>0){
      // Check if all items are now fully received
      const client2=window.supabase.createClient(window.IMS_SUPABASE_URL,window.IMS_SUPABASE_ANON_KEY);
      const {data:allItems}=await client2.from('po_items').select('quantity,qty_received').eq('po_id',poId);
      const allDone=(allItems||[]).length>0&&(allItems||[]).every(i=>(i.qty_received||0)>=(i.quantity||0));
      await db().update('purchase_orders',poId,{status:allDone?'completed':'partially_received'});
      ui().closeModal();
      setTimeout(()=>{
        ui().openModal('Goods received — next steps',`
          <div class="ims__alert ims__alert--success" style="margin-bottom:14px">
            <i class="ti ti-check"></i>
            <span><strong>${totalReceived} units</strong> received and added to stock.</span>
          </div>
          <p style="font-size:13px;color:var(--ims-text-sec);margin-bottom:16px">What would you like to do next?</p>
          <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px">
            <div class="ims__card" style="cursor:pointer;text-align:center;padding:20px" onclick="window.IMS_PURCHASES.printPutAwayForPO('${poId}');window.SM.UI.closeModal()">
              <i class="ti ti-printer" style="font-size:28px;color:var(--ims-accent);margin-bottom:8px;display:block"></i>
              <div style="font-weight:600;font-size:13px">Print put-away sheet</div>
              <div style="font-size:12px;color:var(--ims-text-muted);margin-top:4px">For warehouse staff to fill in bin locations</div>
            </div>
            <div class="ims__card" style="cursor:pointer;text-align:center;padding:20px" onclick="window.IMS_PURCHASES.enterPutAwayLocations('${poId}');window.SM.UI.closeModal()">
              <i class="ti ti-map-pin" style="font-size:28px;color:var(--ims-success);margin-bottom:8px;display:block"></i>
              <div style="font-weight:600;font-size:13px">Enter bin locations</div>
              <div style="font-size:12px;color:var(--ims-text-muted);margin-top:4px">Update stock locations from completed put-away sheet</div>
            </div>
          </div>
        `,`<button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Skip for now</button>`,'sm');
      },400);
      load();
    } else {
      ui().toast('No quantities entered','warning');
    }
  }

  async function showSuppliers(){
    const {data:suppliers}=await db().select('suppliers',{order:{col:'name'}});
    const items=suppliers||[];
    ui().openModal('Suppliers',`
      <div style="display:flex;justify-content:flex-end;margin-bottom:12px">
        <button class="ims__btn ims__btn--primary ims__btn--sm" onclick="window.IMS_PURCHASES.showNewSupplierForm()"><i class="ti ti-plus"></i> Add supplier</button>
      </div>
      <div class="ims__table-wrap">
        <table class="ims__table">
          <thead><tr><th>Name</th><th>Country</th><th>Contact</th><th>Email</th><th>Currency</th><th>Terms</th><th></th></tr></thead>
          <tbody>${items.map(s=>`<tr>
            <td><strong>${util().sanitize(s.name)}</strong></td>
            <td>${util().sanitize(s.country||'—')}</td>
            <td>${util().sanitize(s.contact_name||'—')}</td>
            <td>${util().sanitize(s.email||'—')}</td>
            <td>${s.currency||'GBP'}</td>
            <td>${util().sanitize(s.payment_terms||'—')}</td>
            <td><button class="ims__btn ims__btn--secondary ims__btn--sm ims__btn--icon" onclick="window.IMS_PURCHASES.editSupplier('${s.id}')"><i class="ti ti-edit"></i></button></td>
          </tr>`).join('')||'<tr><td colspan="7" class="ims__table-empty">No suppliers yet</td></tr>'}
          </tbody>
        </table>
      </div>
    `,`<button class="ims__btn ims__btn--primary" onclick="window.SM.UI.closeModal()">Close</button>`,'lg');
  }

  async function showNewSupplierForm(existingId=null){
    let s=null;
    if(existingId){const {data}=await db().select('suppliers',{eq:{id:existingId},maybeSingle:true,noCompanyFilter:true});s=data;}
    ui().openModal(existingId?`Edit: ${s?.name}`:'Add supplier',`
      <div class="ims__form-grid">
        <div class="ims__form-group ims__form-group--full"><label class="ims__label ims__label--req">Supplier name</label><input class="ims__input" type="text" id="ims-sup-name" value="${util().sanitize(s?.name||'')}"></div>
        <div class="ims__form-group"><label class="ims__label">Contact name</label><input class="ims__input" type="text" id="ims-sup-contact" value="${util().sanitize(s?.contact_name||'')}"></div>
        <div class="ims__form-group"><label class="ims__label">Email</label><input class="ims__input" type="email" id="ims-sup-email" value="${util().sanitize(s?.email||'')}"></div>
        <div class="ims__form-group"><label class="ims__label">Phone</label><input class="ims__input" type="tel" id="ims-sup-phone" value="${util().sanitize(s?.phone||'')}"></div>
        <div class="ims__form-group"><label class="ims__label">Country</label><input class="ims__input" type="text" id="ims-sup-country" value="${util().sanitize(s?.country||'')}" placeholder="e.g. China, UK"></div>
        <div class="ims__form-group"><label class="ims__label">Currency</label><select class="ims__select" id="ims-sup-currency"><option value="GBP" ${s?.currency==='GBP'?'selected':''}>GBP (£)</option><option value="USD" ${s?.currency==='USD'?'selected':''}>USD ($)</option><option value="EUR" ${s?.currency==='EUR'?'selected':''}>EUR (€)</option><option value="CNY" ${s?.currency==='CNY'?'selected':''}>CNY (¥)</option><option value="PKR" ${s?.currency==='PKR'?'selected':''}>PKR (₨)</option></select></div>
        <div class="ims__form-group"><label class="ims__label">Payment terms</label><input class="ims__input" type="text" id="ims-sup-terms" value="${util().sanitize(s?.payment_terms||'')}" placeholder="e.g. 30 days net"></div>
        <div class="ims__form-group"><label class="ims__label">VAT number</label><input class="ims__input" type="text" id="ims-sup-vat" value="${util().sanitize(s?.vat_number||'')}"></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label">Address</label><textarea class="ims__textarea" id="ims-sup-address" rows="2">${util().sanitize(s?.address||'')}</textarea></div>
        <div class="ims__form-group ims__form-group--full"><label class="ims__label">Notes</label><textarea class="ims__textarea" id="ims-sup-notes" rows="2">${util().sanitize(s?.notes||'')}</textarea></div>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.IMS_PURCHASES.showSuppliers()">Back</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_PURCHASES.saveSupplier('${existingId||''}')"><i class="ti ti-check"></i> Save</button>
    `,'lg');
  }

  async function saveSupplier(existingId){
    const g=id=>document.getElementById(id)?.value?.trim()||'';
    const name=g('ims-sup-name');
    if(!name){ui().toast('Supplier name required','error');return;}
    const data={name,contact_name:g('ims-sup-contact'),email:g('ims-sup-email'),phone:g('ims-sup-phone'),country:g('ims-sup-country'),currency:g('ims-sup-currency')||'GBP',payment_terms:g('ims-sup-terms'),vat_number:g('ims-sup-vat'),address:g('ims-sup-address'),notes:g('ims-sup-notes')||null};
    const {error}=existingId?await db().update('suppliers',existingId,data):await db().insert('suppliers',data);
    if(error){ui().toast('Failed: '+error.message,'error');return;}
    ui().toast(`Supplier ${existingId?'updated':'added'}`,'success');
    showSuppliers();
  }

  async function printPutAwayForPO(poId){
    const {data:po}=await db().select('purchase_orders',{select:'po_number,po_items(qty_received,product_name,sku,products(name,sku,default_bin))',eq:{id:poId},maybeSingle:true,noCompanyFilter:true});
    if(!po)return;
    const infoRows=[['PO Number',util().sanitize(po.po_number)],['Date',util().formatDate(new Date().toISOString())]];
    const infoTableHtml=window.PRINT.table({colWidths:['30%','70%'],columns:[{label:'Field'},{label:'Value'}],rows:infoRows});
    const itemRows=(po.po_items||[]).filter(i=>(i.qty_received||0)>0).map(i=>[
      util().sanitize(i.product_name||i.products?.name||'—'),
      util().sanitize(i.sku||i.products?.sku||'—'),
      String(i.qty_received||0),
      `<span style="color:#2563EB">${util().sanitize(i.products?.default_bin||'—')}</span>`,
      '&nbsp;','&nbsp;'
    ]);
    const itemTableHtml=window.PRINT.table({
      colWidths:['28%','16%','12%','16%','16%','12%'],
      columns:[{label:'Product'},{label:'SKU'},{label:'Qty'},{label:'Default bin'},{label:'Assigned location'},{label:'Sign'}],
      rows:itemRows
    });
    const sigFooterHtml=`<div style="margin-top:20px;display:flex;gap:40px;align-items:center;font-size:9pt">
      <div>Completed by: ${window.PRINT.signatureBox(140)}</div>
      <div>Date: ${window.PRINT.signatureBox(140)}</div>
      <div>Signature: ${window.PRINT.signatureBox(140)}</div>
    </div>
    <div style="margin-top:10px;font-size:8pt;color:#666">Return this sheet to office once complete.</div>`;
    const page=`${window.PRINT.header({title:'Put Away Sheet',docRef:po.po_number})}<hr class="rule">${infoTableHtml}<div class="st" style="margin-top:14px">Products to locate</div><hr class="rule">${itemTableHtml}${sigFooterHtml}`;
    window.PRINT.renderDocument([page],`Put Away — ${po.po_number}`);
  }

  async function enterPutAwayLocations(poId){
    const {data:po}=await db().select('purchase_orders',{select:'po_number,po_items(id,product_id,product_name,sku,qty_received,products(name,sku,default_bin))',eq:{id:poId},maybeSingle:true,noCompanyFilter:true});
    if(!po)return;
    const items=(po.po_items||[]).filter(i=>(i.qty_received||0)>0);
    if(!items.length){ui().toast('No received items to locate','warning');return;}

    // Fetch current bin references
    const {data:whs}=await db().select('warehouses',{eq:{is_active:true}});
    const whId=whs?.[0]?.id;
    const stockLevels={};
    if(whId){
      await Promise.all(items.map(async item=>{
        if(!item.product_id)return;
        const {data:sl}=await db().select('stock_levels',{eq:{product_id:item.product_id,warehouse_id:whId},maybeSingle:true,noCompanyFilter:true});
        if(sl)stockLevels[item.product_id]=sl;
      }));
    }

    ui().openModal(`Enter put-away locations: ${po.po_number}`,`
      <div class="ims__alert ims__alert--info" style="margin-bottom:14px">
        <i class="ti ti-info-circle"></i>
        <span>Enter the bin location where each product was placed. Leave blank to keep the current location.</span>
      </div>
      <div class="ims__table-wrap">
        <table class="ims__table">
          <thead><tr><th>Product</th><th>SKU</th><th>Qty received</th><th>Current bin</th><th>New bin location</th></tr></thead>
          <tbody>${items.map((item,i)=>{
            const currentBin=stockLevels[item.product_id]?.bin_reference||item.products?.default_bin||'—';
            return`<tr>
              <td>${util().sanitize(item.product_name||item.products?.name||'—')}</td>
              <td style="font-size:11px">${util().sanitize(item.sku||item.products?.sku||'—')}</td>
              <td>${item.qty_received||0}</td>
              <td style="color:var(--ims-text-muted)">${util().sanitize(currentBin)}</td>
              <td><input class="ims__input" type="text" id="ims-pa-bin-${i}"
                data-product-id="${item.product_id||''}"
                placeholder="${util().sanitize(currentBin)}"
                style="width:120px"></td>
            </tr>`;
          }).join('')}
          </tbody>
        </table>
      </div>
    `,`
      <button class="ims__btn ims__btn--ghost" onclick="window.SM.UI.closeModal()">Skip</button>
      <button class="ims__btn ims__btn--primary" onclick="window.IMS_PURCHASES.savePutAwayLocations(${items.length},'${whId||''}')"><i class="ti ti-check"></i> Save locations</button>
    `,'lg');
  }

  async function savePutAwayLocations(itemCount,warehouseId){
    if(!warehouseId){ui().toast('No warehouse found','error');return;}
    let updated=0;
    for(let i=0;i<itemCount;i++){
      const input=document.getElementById(`ims-pa-bin-${i}`);
      if(!input)continue;
      const bin=input.value?.trim();
      if(!bin)continue; // blank = keep existing, skip
      const productId=input.dataset.productId;
      if(!productId)continue;
      const {data:sl}=await db().select('stock_levels',{eq:{product_id:productId,warehouse_id:warehouseId},maybeSingle:true,noCompanyFilter:true});
      if(sl){
        await db().update('stock_levels',sl.id,{bin_reference:bin,last_updated:new Date().toISOString()});
        updated++;
      }
    }
    ui().closeModal();
    ui().toast(`${updated} bin location${updated!==1?'s':''} updated`,'success');
    load();
  }

  async function editSupplier(id){showNewSupplierForm(id);}

  window.addEventListener('ims:panel',e=>{if(e.detail.panel==='purchases')load();});
  window.addEventListener('ims:ready',()=>{
    document.getElementById('ims-po-new-btn')?.addEventListener('click',showNewPO);
    document.getElementById('ims-suppliers-btn')?.addEventListener('click',showSuppliers);
    ['ims-po-search','ims-po-status'].forEach(id=>{
      const el=document.getElementById(id);
      if(!el)return;
      el.addEventListener('input',util().debounce(load,350));
      el.addEventListener('change',load);
    });
  });

  window.IMS_PURCHASES={load,openPO,updatePOStatus,deletePO,showNewPO,onSupplierChange,addPOItem,updatePOItem,removePOItem,searchPOProduct,selectPOProduct,savePO,printPO,receiveGoods,confirmReceiving,printPutAwayForPO,enterPutAwayLocations,savePutAwayLocations,showSuppliers,showNewSupplierForm,saveSupplier,editSupplier};

})();
